const DUNE_API_URL = "/api/dune/api/v1/query";

export const fetchDuneQuery = async (queryId) => {
  const url = `${DUNE_API_URL}/${queryId}/results?allow_partial_results=true`;
  const response = await fetch(url, {
  });

  if (!response.ok) {
    throw new Error(`Dune query ${queryId} failed: ${response.status}`);
  }

  const result = await response.json();
  return Array.isArray(result?.result?.rows) ? result.result.rows : [];
};
